import { useState, useEffect, useContext } from 'react';
import { BrowserFeatureContext } from '../../Context/BrowserFeatureContext';
export function useSupportsNativeLazyLoading() {
    var defaultValue = useContext(BrowserFeatureContext).supportsLazy;
    var _a = useState(defaultValue), supportsLazy = _a[0], setSupportsLazy = _a[1];
    useEffect(function () {
        if (typeof HTMLImageElement !== 'undefined' &&
            'loading' in HTMLImageElement.prototype) {
            setSupportsLazy(true);
        }
        else {
            setSupportsLazy(false);
        }
    }, []);
    return supportsLazy;
}
//# sourceMappingURL=useSupportsNativeLazyLoading.js.map